import { jsx } from "react/jsx-runtime";
import PanToolIcon from "@mui/icons-material/PanTool";
import { validateTidalLicense } from "../../base/index.js";
function PanTool(props) {
  return /* @__PURE__ */ jsx(
    PanToolIcon,
    {
      "data-testid": "PanTool",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PanTool",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
PanTool.tidalIconMeta = {
  categories: "map,location,time",
  name: "PanTool"
};
validateTidalLicense();
export {
  PanTool
};
//# sourceMappingURL=PanTool.js.map
